<div class="filter-container">
  <button mat-icon-button type="button"
          [matMenuTriggerFor]="filterMenu" #menuTrigger="matMenuTrigger" (click)="fillMenu(false)">
    <mat-icon>arrow_drop_down</mat-icon>
  </button>
  <mat-form-field class="filter-search">
    <mat-chip-grid #chipList>
      <mat-chip-row
        *ngFor="let selChip of currentChips"
        [removable]="true"
        (removed)="removeChip(selChip)" color="primary" selected="true" (click)="fillMenu(true)">
        {{ selChip.label }}
        <mat-icon matChipRemove class="chip-icon">cancel</mat-icon>
      </mat-chip-row>
      <input
        placeholder="Filtern..."
        class="filter-input"
        #filterInput
        [formControl]="inputCtrl"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
    </mat-chip-grid>
    <mat-menu #filterMenu="matMenu" xPosition="after" (click)="$event.stopPropagation()">
      <div (click)="$event.stopPropagation()" mat-menu-item class="filter-menu-item">
        <mat-icon>receipt</mat-icon>
        <mat-form-field class="compact-form-field">
          <input matInput placeholder="Polizzen-Nr" [(ngModel)]="polNr" (keyup.enter)="applyFilter()">
        </mat-form-field>
      </div>
      <div (click)="$event.stopPropagation()" mat-menu-item class="filter-menu-item">
        <mat-icon>date_range</mat-icon>
        <div class="date-filter-item">
          <mat-form-field class="compact-form-field">
            <input matInput placeholder="ab Beginndatum" [matDatepicker]="fromDP" [(ngModel)]="beginFromDate"
                   (keyup.enter)="applyFilter()">
          </mat-form-field>
          <mat-datepicker-toggle matSuffix [for]="fromDP" class="filter-date-toggle">
            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
          </mat-datepicker-toggle>
        </div>
        <mat-datepicker #fromDP></mat-datepicker>
      </div>
      <div (click)="$event.stopPropagation()" mat-menu-item class="filter-menu-item">
        <mat-icon>date_range</mat-icon>
        <div class="date-filter-item">
          <mat-form-field class="compact-form-field">
            <input matInput placeholder="bis Beginndatum" [matDatepicker]="untilDP" [(ngModel)]="beginToDate"
                   (keyup.enter)="applyFilter()">
          </mat-form-field>
          <mat-datepicker-toggle matSuffix [for]="untilDP" class="filter-date-toggle">
            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
          </mat-datepicker-toggle>
        </div>
        <mat-datepicker #untilDP></mat-datepicker>
      </div>
      <!-- ausblenden wenn "Makler" -->
      @if (userService.isNotAuthorized$('PZ_MAKLER') | async) {
        <div (click)="$event.stopPropagation()" mat-menu-item class="filter-menu-item">
          <mat-icon>person</mat-icon>
          <mat-form-field class="compact-form-field">
            <input matInput placeholder="Betreuer-Nr" [(ngModel)]="btrNr" (keyup.enter)="applyFilter()">
          </mat-form-field>
        </div>
      }
      <!-- ausblenden wenn "Makler" -->
      @if (userService.isNotAuthorized$('PZ_MAKLER') | async) {
        <div (click)="$event.stopPropagation()" mat-menu-item class="filter-menu-item">
          <mat-icon>loyalty</mat-icon>
          <mat-form-field class="compact-form-field">
            <input matInput placeholder="Bearbeiter" [(ngModel)]="bearbeiter" (keyup.enter)="applyFilter()">
          </mat-form-field>
        </div>
      }
      <div (click)="$event.stopPropagation()" mat-menu-item class="filter-menu-item">
        <mat-icon>info</mat-icon>
        <mat-form-field class="compact-form-field">
          <mat-select [(ngModel)]="vkeTyp" placeholder="Vke Typ">
            <mat-option *ngFor="let typ of vkeTypen" value="{{typ}}">{{ typ }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div (click)="$event.stopPropagation()" mat-menu-item class="filter-menu-item">
        <mat-icon>directions_car</mat-icon>
        <mat-form-field class="compact-form-field">
          <input matInput placeholder="Kennzeichen" [(ngModel)]="kfzKz" (keyup.enter)="applyFilter()">
        </mat-form-field>
      </div>
      <div (click)="$event.stopPropagation()" mat-menu-item class="filter-menu-item">
        <mat-icon>event_available</mat-icon>
        <div class="date-filter-item">
          <mat-form-field class="compact-form-field">
            <input matInput placeholder="ab Erstelldatum" [matDatepicker]="erstellFromDP" [(ngModel)]="erstellFromDate"
                   (keyup.enter)="applyFilter()">
          </mat-form-field>
          <mat-datepicker-toggle matSuffix [for]="erstellFromDP" class="filter-date-toggle">
            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
          </mat-datepicker-toggle>
        </div>
        <mat-datepicker #erstellFromDP></mat-datepicker>
      </div>
      <div (click)="$event.stopPropagation()" mat-menu-item class="filter-menu-item">
        <mat-icon>event_available</mat-icon>
        <div class="date-filter-item">
          <mat-form-field class="compact-form-field">
            <input matInput placeholder="bis Erstelldatum" [matDatepicker]="erstellUntilDP" [(ngModel)]="erstellToDate"
                   (keyup.enter)="applyFilter()">
          </mat-form-field>
          <mat-datepicker-toggle matSuffix [for]="erstellUntilDP" class="filter-date-toggle">
            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
          </mat-datepicker-toggle>
        </div>
        <mat-datepicker #erstellUntilDP></mat-datepicker>
      </div>
      <div (click)="$event.stopPropagation()" mat-menu-item class="filter-menu-item full-width">
        <button mat-raised-button type="button" class="filter-button" color="accent" (click)="applyFilter()">
          Filtern
        </button>
      </div>
    </mat-menu>
  </mat-form-field>
</div>
